import React, { useState, useEffect } from "react";

//MUI
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { Button }  from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Box, FormControl, Stack, TextField, Typography, MenuItem, Select } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import USnackbar from "../../components/mui/USnackbar";
import UButton from "../../components/mui/UButton";
import UAuthButton from "../../components/mui/UAuthButton";

//API
import AuthenticationService from "../../pages/auth/AuthenticationService";
import { getAPI, putAPI } from "../../services/commonService";
import { API } from "../../config";
import { fni18n } from "../../services/commonService";
import { theme } from '../../assets/themes';

const GroupAuthForm = (props) => {
    const grpCd = props.grpCd;
    const [ menuList, setMenuList ] = useState([]); //메뉴정보
    const [ initMenuList, setInitMenuList ] = useState([]); //초기메뉴정보

    const [ grpNm, setGrpNm ] = useState(""); //그룹명
    const menuAuthCombo = [ //메뉴권한combobox
      {useAuth:'0', description:'없음'},
      {useAuth:'10', description:'모든'},
      {useAuth:'40', description:'조회'},
    ]; 
    const pmenuAuthCombo = [ //메뉴권한combobox
      {useAuth:'0', description:'닫힘'},
      {useAuth:'40', description:'열림'},
    ] ; 
    const [ changeVal, setChangeVal ] = useState([]); //변경정보
    const [ snackOpen, setSnackOpen ] = useState(false);
    const [ snackSeverity, setSnackSeverity ] = useState('success');
    const [ snackMessage, setSnackMessage ] = useState('');
     
    const isUserId = AuthenticationService.getLoggedInUserID();
    //화면 그리기    
    useEffect(() => {
        try {
            loadMenu();
          } catch (e) {
            console.log(e);
          }
    }, [grpCd]);

    //화면 그리기
    const loadMenu = async () => {
        try {
          let param = {
            grpCd:  grpCd,
            userId: isUserId,
          };
        await getAPI(API.SYSTEM.MENU_AUTH, param)
        .then((res) => {
                setMenuList(res.data.result);
                setInitMenuList(res.data.result);
                setGrpNm(res.data.result[0].grpNm)
            }
          )
          .catch((err)=>{
            console.log(err)
          });
        } catch (e) {
          console.log(e)
        }
    }
    //수정 함수
    const handleSave = () => {
      Object.keys(changeVal).map(key => {
        let param = {
          grpCd:  props.grpCd,
          userId: isUserId,
          menuNo: key,
          useAuth: changeVal[key],
        };
        try {
          putAPI(API.SYSTEM.MENU_AUTH, param)
          .then((res) => {
            if (res.data.code === 200) {
                // snack bar success open
                setSnackMessage(res.data.message);
                handleSnackOpen();
            } else {
                // snack bar error open
                setSnackMessage(res.data.message);
                setSnackSeverity("error")
                handleSnackOpen();
            }
          })
          .catch((err)=>{
            console.log(err)
          });
        } catch (e) {
          console.log(e)
        }
      })
    }
    //정보 변경시 setter
    const handleChange = (e) => {
      const { name, value } = e.target;
      setChangeVal({
        ...changeVal,
        [name]: value,
      });
      setMenuList(
        menuList.map(item =>
          item.menuNo === name ?
          {
              ...item,
              useAuth: value
          }
          :item
        )
      )
    }
    //성공 스낵바 
    const handleSnackOpen = () => {
      props.onClose();
      setSnackOpen(true);
    };
    const handleSnackClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }
        setSnackOpen(false);
    };
    
    //popup close
    const closePopupForm = () =>{
      props.onClose();
      setMenuList(initMenuList);
    }

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.onClose}
                // PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth="xl"
            >
                <DialogTitle style={{ backgroundColor: "#F6F6F6", color:"#2F2F2F", borderBottom: "1px solid #444444", height:"50px", fontSize:"20px"}} id="draggable-dialog-title" onClose={props.onClose}>
                    { props.title || "Alert" }
                    <IconButton
                    aria-label="close"
                    onClick={props.onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                    <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                <DialogContentText>
            {/* 조회 리스트 선택 상세  */}
              <Box className="pop-container">
              <div className="contents">
                <TableContainer className="table-container">
                  <Table className="table" size="small">
                    <TableBody>
                      <TableRow>
                        <TableCell className="table-cell-title">{fni18n('그룹명')}</TableCell>
                        <TableCell className="table-cell">
                          <FormControl>
                          <TextField
                          name="grpNm"
                          size="small"
                          hiddenLabel
                          value={grpNm}
                          disabled
                          InputProps={{
                              readOnly: true,
                          }}
                          />
                          </FormControl>
                        </TableCell>
                        <TableCell className="table-cell"></TableCell>
                        <TableCell className="table-cell"></TableCell>
                        <TableCell className="table-cell"></TableCell>
                        <TableCell className="table-cell"></TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
                <Stack direction="column">
                    <Stack
                    direction="row"
                    justifyContent="space-evenly"
                    alignItems="flex-start"
                    spacing={0}
                    mt={2}
                    >
                {menuList &&
                    menuList.filter(pmenu => !pmenu.pmenuNo )
                    .map((pmenu) => (
                        <div key={pmenu.menuNo}>
                        {/* <Stack
                        key={pmenu.menuNo}
                        direction="row"
                        justifyContent="flex-start"
                        mb={2}
                        >

                            <li>{fni18n(`${pmenu.menuNm}`)}</li>
                            <Select
                                id="cbx_menuList"
                                name={pmenu.menuNo || ""}
                                size="small"
                                value={pmenu.useAuth}
                                sx={{ ml: 0.8, width: "11vh" }}
                                onChange={e => handleChange(e)}
                                >
                                {menuAuthCombo.map((auth) => (
                                    <MenuItem key={auth.useAuth} value={auth.useAuth}>
                                        {fni18n(`${auth.description}`)}
                                    </MenuItem>
                                    ))}
                                </Select>
                        </Stack> */}
                        <TableContainer  className="table-container" >
                          <Table className="table" size="large">
                          <TableBody key={pmenu.menuNo}>
                            <TableRow>
                              <TableCell className="table-cell"><li>{fni18n(`${pmenu.menuNm}`)}</li></TableCell>
                              <TableCell className="table-cell">
                                <Select
                                id="cbx_menuList"
                                name={pmenu.menuNo || ""}
                                size="small"
                                value={pmenu.useAuth}
                                sx={{ ml: 0.8, width: "11vh" }}
                                onChange={e => handleChange(e)}
                                >
                                {pmenuAuthCombo.map((auth) => (
                                  <MenuItem key={auth.useAuth} value={auth.useAuth}>
                                      {fni18n(`${auth.description}`)}
                                  </MenuItem>
                                ))}
                                </Select>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                          </Table>
                        </TableContainer>
                        <TableContainer  className="table-container" >
                          <Table className="table" size="small">
                        {menuList &&
                        menuList.filter(cmenu => cmenu.pmenuNo && pmenu.menuNo === cmenu.pmenuNo)
                        .map((cmenu) => (
                            <TableBody key={cmenu.menuNo+cmenu.pmenNo}>
                            <TableRow>
                                <TableCell className="table-cell-title">{fni18n(`${cmenu.menuNm}`)}</TableCell>
                                <TableCell className="table-cell">
                                <Select
                                id="cbx_menuList"
                                name={cmenu.menuNo || ""}
                                size="small"
                                value={cmenu.useAuth}
                                sx={{ ml: 0.8, width: "11vh" }}
                                onChange={e => handleChange(e)}
                                >
                                {menuAuthCombo.map((auth) => (
                                    <MenuItem key={auth.useAuth} value={auth.useAuth}>
                                        {fni18n(`${auth.description}`)}
                                    </MenuItem>
                                    ))}
                                </Select>
                                </TableCell>
                            </TableRow>
                            </TableBody>            
                        ))}
                        </Table>
                        </TableContainer>
                        </div>
                    ))}
                    </Stack>
                </Stack>
              </div>
              </Box>
                </DialogContentText>
                </DialogContent>
                <DialogActions sx={{align: "center", backgroundColor:"#F6F6F6"}}>
                    <UAuthButton variant="contained" color="primary" onButtonClick={handleSave}>저장</UAuthButton>
                    <UButton variant="outlined" onButtonClick={ props.onClose }>닫기</UButton>
                </DialogActions>
            </Dialog>
            {/* 성공 스낵바  */}
            <USnackbar
            open={snackOpen}
            onClose={handleSnackClose}
            severity={snackSeverity}
            message={snackMessage}
            />
        </div>
    )
}
export default GroupAuthForm;

function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
}